import type { ConsoleOrganization } from '@sentinel/shared';
import { StateBadge, type Column } from '@sentinel/ui';
import { formatDate } from '@sentinel/web-core';
import type { TFunction } from 'i18next';
import { ORGANIZATION_TONE, usageOf } from './organization-state';

const K = 'console.organizations';

export function organizationColumns(t: TFunction): Column<ConsoleOrganization>[] {
  return [
    {
      key: 'name',
      header: t(`${K}.columns.name`),
      render: (o) => (
        <>
          <b>{o.name}</b>
          <span className="sub">{t(`console.kinds.${o.kind}`)}</span>
        </>
      ),
    },
    {
      key: 'status',
      header: t(`${K}.columns.status`),
      render: (o) => (
        <StateBadge tone={ORGANIZATION_TONE[o.status]} label={t(`console.statuses.${o.status}`)} />
      ),
    },
    {
      key: 'plan',
      header: t(`${K}.columns.plan`),
      render: (o) => (o.planKey === null ? '—' : t(`console.plans.${o.planKey}`)),
    },
    {
      key: 'users',
      header: t(`${K}.columns.users`),
      mono: true,
      render: (o) => usageOf(o.usage.users, o.limits.maxUsers),
    },
    {
      key: 'missions',
      header: t(`${K}.columns.missions`),
      mono: true,
      render: (o) => usageOf(o.usage.activeMissions, o.limits.maxActiveMissions),
    },
    {
      key: 'created',
      header: t(`${K}.columns.created`),
      mono: true,
      render: (o) => formatDate(o.createdAt),
    },
  ];
}
